import { FormSection } from '@strata/react-form-section';
import { QuestionForm } from '@strata/react-question-tree';
import PropTypes from 'prop-types';
import { useState } from 'react';

export const TestTab = ({ questions = undefined }) => {
    const [answers, setAnswers] = useState([]);

    return (
        <div className="sds_policy-edit">
            <FormSection
                sectionTitle="Test Policy"
                isLoading={!questions}
                content={
                    <QuestionForm
                        nodes={questions}
                        answers={answers}
                        showClinicalPolicyMessaging
                        onSectionSubmit={setAnswers}
                    />
                }
            />
        </div>
    );
};

TestTab.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.shape({})),
};
